import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import FieldInformation from '@app/store/contract-progress/FieldInformation';

export interface ContractProgressFieldInformationState {
  [id: string]: FieldInformation;
}

const initialState: ContractProgressFieldInformationState = {};

export default function reducer(
  state: ContractProgressFieldInformationState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
